class ProductDetails extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.mainProductWrapperEle = document.querySelector(`.section-main-product`);
    this.sectionProductDetails = this.closest('.section-product-details');
    this.minTabletWidth = MIN_DEVICE_WIDTH.tablet;

    this.captureOriginalPosition();

    if (this.isPairedWithMainProduct) {
      this.setupHighlightFeature();
      this.syncLayout();
    }

    this.classList.remove('hidden');
    window.addEventListener('resize', this.debounce(() => {
      this.syncLayout();
    }, 200));

    if (Shopify.designMode) {
      window.addEventListener('shopify:section:load', (event) => {
        if (this.mainProductWrapperEle && this.mainProductWrapperEle.id.includes(event.detail.sectionId)) {
          this.setupHighlightFeature();
          this.syncLayout();
        }
      });
      window.addEventListener('shopify:section:reorder', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.restoreOriginalPosition();
          this.mainProductWrapperEle = document.querySelector('.section-main-product');
          this.captureOriginalPosition();
          this.setupHighlightFeature();
          this.syncLayout();
        }
      });
    }
  }

  // The section is paired with the main product only when it directly follows
  // it in the DOM. Cache that (and the original spot to restore to) once, up
  // front — teleportIntoMedia() moves this node so it's no longer a sibling of
  // .section-main-product, and we still need to know where "home" is.
  captureOriginalPosition() {
    this.isPairedWithMainProduct = !!(
      this.mainProductWrapperEle &&
      this.sectionProductDetails &&
      this.sectionProductDetails.previousElementSibling === this.mainProductWrapperEle
    );
    if (this.isPairedWithMainProduct) {
      this.originalParent = this.sectionProductDetails.parentElement;
      this.originalNextSibling = this.sectionProductDetails.nextSibling;
    }
  }

  setupHighlightFeature() {
    const productInfoEle = this.mainProductWrapperEle.querySelector('.product-template__wrapper');
    const highlightFeatureWrappers = this.querySelectorAll('.product-details__highlight-feature__grid');

    if (!productInfoEle) return;

    var maxGridColumn = "4";
    if (this.isPairedWithMainProduct) {
      maxGridColumn = productInfoEle.dataset.desktopMediaWidth === 'default' ? "2" : "3";
    }

    highlightFeatureWrappers.forEach(wrapper => {
      wrapper.dataset.maxGridColumn = maxGridColumn;
      wrapper.style.display = 'flex';
    });
  }

  // On desktop, move the section into the product image column so it lays out
  // with normal block flow (no floats, no JS-computed margin/height sync) —
  // that cross-section float sync was the source of the Firefox blank-space
  // bug. On mobile, put it back where it started.
  syncLayout() {
    if (!this.isPairedWithMainProduct) return;
    if (window.matchMedia(`(min-width: ${this.minTabletWidth}px)`).matches) {
      this.teleportIntoMedia();
    } else {
      this.restoreOriginalPosition();
    }
  }

  teleportIntoMedia() {
    const mediaWrapperEle = this.mainProductWrapperEle.querySelector('.product-template__media-wrapper');
    if (!mediaWrapperEle || this.sectionProductDetails.parentElement === mediaWrapperEle) return;
    mediaWrapperEle.appendChild(this.sectionProductDetails);
    document.dispatchEvent(new CustomEvent(`${PRODUCT_EVENT.productDetailsLayoutChange}${this.mainProductSectionId()}`));
  }

  restoreOriginalPosition() {
    if (!this.originalParent || this.sectionProductDetails.parentElement === this.originalParent) return;
    this.originalParent.insertBefore(this.sectionProductDetails, this.originalNextSibling);
    document.dispatchEvent(new CustomEvent(`${PRODUCT_EVENT.productDetailsLayoutChange}${this.mainProductSectionId()}`));
  }

  mainProductSectionId() {
    const productInfoEle = this.mainProductWrapperEle.querySelector('.product-template__wrapper');
    return productInfoEle ? productInfoEle.dataset.sectionId : '';
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }
}

if (!customElements.get('product-details')) {
  customElements.define('product-details', ProductDetails);
}
